import { object, string } from "yup";
import isIpAddress, { isPublicIpAddress } from "/app/src/helpers/validators";
import i18next from "/app/src/locales/config";

export const mssqlSchema = (isCloud: boolean) =>
  object().shape({
    username: string().required(i18next.t("translation:username_is_required")),
    password: string().required(i18next.t("translation:password_is_required")),
    token: string().required(i18next.t("translation:databaseName_is_required")),
    url: string()
      .required(i18next.t("translation:address_is_required"))
      .test("test-name", i18next.t("translation:valid_address"), (value) => {
        if (!value) return false;
        return isIpAddress(value);
      })
      .test(
        "test-name",
        i18next.t("translation:cloud_public_ip_required"),
        (value) => {
          if (!isCloud) return true;
          if (!value) return false;
          return isPublicIpAddress(value);
        },
      ),
  });

export const mssqlSchemaNoPwd = (isCloud: boolean) =>
  object().shape({
    username: string().required(i18next.t("translation:username_is_required")),
    password: string(),
    token: string(),
    url: string()
      .required(i18next.t("translation:address_is_required"))
      .test("test-name", i18next.t("translation:valid_address"), (value) => {
        if (!value) return false;
        return isIpAddress(value);
      })
      .test(
        "test-name",
        i18next.t("translation:cloud_public_ip_required"),
        (value) => {
          if (!isCloud) return true;
          if (!value) return false;
          return isPublicIpAddress(value);
        },
      ),
  });
